import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import useOutsideClick from "lib/hooks/useOutsideClick";
import styles from "./SlideOver.module.scss";

function SlideOver(
  { children, isActive, handleCloseButtonClick, position = "page" },
  ref
) {
  const positionClass = styles[position];

  const outsideClickRef = useOutsideClick(handleCloseButtonClick);

  return (
    <aside
      ref={outsideClickRef}
      className={`${styles.slideOver} 
      ${positionClass}
      ${isActive ? styles.isActive : styles.notActive}
      `}
    >
      <div className={`${styles.closeButton}`} onClick={handleCloseButtonClick}>
        <BsArrowLeft style={{ fill: "currentColor" }} size="1.5rem" />
      </div>
      <div className={`${styles.content}`}>{children}</div>
    </aside>
  );
}

export default SlideOver;
